'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.LiteDataService', 'AVRO.Rules.RuleData'];
module.exports = angular.module('AVRO.Rules.WhatIf', dependencies).factory('WhatIfService', require('./services/WhatIfService'));